module.exports = __webpack_public_path__ + "img/howtoplay.57359321.svg";